import { API } from 'app/utils/client';
import { ICountry } from 'app/models';
import { CRUDService } from './api';

export class CountryService extends CRUDService<ICountry> { }

const instance = new CountryService(API, 'v1/countries');
export default instance;
